import React from "react";
import Navbar from "./Navbar";

const PeersOffline = () => {
  return (
    <div>
      <Navbar />
      <div style={{ padding: "20px" }}>
        <h1>Peers Offline</h1>
      <p>Bem-vindo à página de Peers Offline!</p>
    </div>
    </div>
  );
};

export default PeersOffline;